import React from 'react';
import { Flex, Box } from '@atlaskit/primitives/compiled';
import Image from '@atlaskit/image';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import src from './JiraLogo.svg';

export const JiraLogoPlaceholder = () => {
	return (
		<Flex justifyContent="center" alignItems="center">
			<Box padding="space.1000">
				<Image src={src} alt="Loading Jira..." />
				<UFOLoadHold name="jira-spa" />
			</Box>
		</Flex>
	);
};
